import {StyledContainerTabs} from '@/features/measures/components/tab/style.ts'
import {FC} from 'react'
import {Chip} from '@components/ui/chip/Chip.tsx'
import {Spinner} from '@components/ui/spinner/Spinner.tsx'

interface TabProps {
    to: string
    label: string
    counter?: string
    isLoading?: boolean
}

export const Tab: FC<TabProps> = ({to, label, counter, isLoading}) => {
    return (
        <StyledContainerTabs to={to}>
            <span className="tab-content">
                {label}
                {isLoading ? <Spinner size={16} /> : counter && <Chip text={counter} />}
            </span>
        </StyledContainerTabs>
    )
}
